import { atom } from "jotai";

export const reconocimientosAtom = atom([]);
export const openModalCrearReconocimientoAtom = atom(false);
export const openModalEditarReconocimientoAtom = atom(false);
export const loadAtom = atom(false);
export const formInstanceAtom = atom(undefined);
export const reconocimientoIdSelecionadoAtom = atom(undefined);
export const colaboradoresAtom = atom([]);